<label class="drawer-label" [for]="labelID">{{ label }}</label>
<div class="configurator-field">
  <select
    [id]="labelID"
    [ngClass]="{ 'font-family': options.type === 'font-family' }"
  >
    <ng-container *ngIf="options.type === 'font-weight'">
      <option
        i18n="@@Light"
        value="300"
        style="--font-weight: 300"
        [selected]="defaultValue === 300"
      >
        Light
      </option>
      <option
        i18n="@@Regular"
        value="400"
        style="--font-weight: 400"
        [selected]="defaultValue === 400"
      >
        Regular
      </option>
      <option
        i18n="@@Semibold"
        value="600"
        style="--font-weight: 600"
        [selected]="defaultValue === 600"
      >
        Semibold
      </option>
      <option
        i18n="@@Bold"
        value="700"
        style="--font-weight: 700"
        [selected]="defaultValue === 700"
      >
        Bold
      </option>
      <option
        i18n="@@Black"
        value="900"
        style="--font-weight: 900"
        [selected]="defaultValue === 900"
      >
        Black
      </option>
    </ng-container>
    <ng-container *ngIf="options.type === 'font-family'">
      <option value="Nunito Sans" style="--font-family: 'Nunito Sans'">
        Nunito Sans
      </option>
      <option value="Open Sans" style="--font-family: 'Open Sans'">
        Open Sans
      </option>
      <option value="Roboto" style="--font-family: 'Roboto'">Roboto</option>
      <option value="Consolas" style="--font-family: 'Consolas'">
        Consolas
      </option>
      <option value="Figtree" style="--font-family: 'Figtree', sans-serif">
        Figtree
      </option>
    </ng-container>
    <ng-container *ngIf="options.type === 'generic'">
      <option
        i18n
        *ngFor="let option of itemList"
        [value]="option.value"
        [selected]="defaultValue === option.value"
      >
        {{ option.text }}
      </option>
    </ng-container>
  </select>
</div>
